import { ChangeDetectionStrategy, Component, Input } from "@angular/core";

import { GridCategory } from "@hermes/states/grid-filters-state";

/**
 * Result header including the collection name, nb of products in the collection, the
 * sort by button and for mobile the filter button displaying the tray
 */
export interface GridResultHeader {
    collectionSize: number;
    facetDisplayName: string;
    currentCategory: GridCategory;
    hideTotalUpdatedItems: boolean;
}
@Component({
    selector: "h-grid-header",
    templateUrl: "./grid-header.component.html",
    styleUrls: ["./grid-header.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GridHeaderComponent {
    @Input()
    public resultGridHeader!: GridResultHeader;
}
